
const StudentResponseGradeSteps = ({response}) => {
    if(!response || !response.responseGradeSteps || response.responseGradeSteps.length === 0){
        return <> </>
    }

    
                   
           
  return (<>
   <span className='grid-results-header'> פירוט ציון</span>
            <span className='grid-results-data'>
  {response.responseGradeSteps.map((step, index) => ( 
        <div key={index} className="border-b border-gray-300  flex gap-2 p-2 items-start">
            <span className="text-xl font-bold">{step.grade}%</span>
            <span className="text-sm font-bold">(מתוך</span>
            <span className="text-sm font-bold">{step.baseGrade}%)</span>
            <h3 className="text-xl font-bold">{step.title}</h3>

            <span className=" text-gray-500">{step.comments}</span>

            
        </div>
        ))}
         </span>
    
    </>)
}
  

export default StudentResponseGradeSteps